import { Injectable } from '@angular/core';
import { Request, Headers, Response } from '@angular/http';
import { HttpClient } from '../../../services/http.service';
import { AppConstants } from '../../../app.constants';
import { Observable } from 'rxjs/Rx';
import { LocalStorageService } from 'ng2-webstorage';
@Injectable()
export class DepartmentService {
    private schoolId: string;
    private categoryId: string;
    constructor(private httpClient: HttpClient, private appConstants: AppConstants, private localStorage: LocalStorageService) {

    }
    //getting sbaccessroles
    public getSbaccessRoles(): Observable<Response> {
        var url: string = '' + this.appConstants.baseUrl + this.appConstants.sbaccessroles + '/' + '?schoolId=' + this.localStorage.retrieve('SchoolId');
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
    }
    //posting Department
    public postDepartment(deptPayload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.UserSpecializationCategory;
        return this.httpClient.Post(url, deptPayload)
            .map(this.extractData)
            .catch(this.handleError)
    }

    public GetCategory(pagenum, searchString, isList, size?): Observable<Response> {
        var pagesize = size ? size : 10;
        if (!searchString) {
            var url: string = '' + this.appConstants.baseUrl + this.appConstants.UserSpecializationCategory + '?schoolId=' + this.localStorage.retrieve('SchoolId')+ '&isList=' + isList + '&PageSize=' + pagesize + '&pageNumber=' + pagenum ;
        }
        else {
            var url: string = '' + this.appConstants.baseUrl + this.appConstants.UserSpecializationCategory + '?schoolId=' + this.localStorage.retrieve('SchoolId') + '&isList=' + isList + '&PageSize=' + pagesize + '&pageNumber=' + pagenum + '&searchString=' + searchString;
        }

        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
    }


    public DeleteDepartment(sbAccessRoleId): Observable<Response> {
        var url: string = '' + this.appConstants.baseUrl + this.appConstants.sbaccessroles + '?sbAccessRoleId=' + sbAccessRoleId;
        return this.httpClient.Delete(url)
            .map(this.extractData)
            .catch(this.handleError)
    }

    private extractData(res: Response) {
        let body = res.json();
        return body;
    }

    private handleError(error: any) {
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        let err = JSON.parse(error._body);
        return Observable.throw(err);
    }
}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/components/manageuser/department/department.service.ts